import {environment} from "../../../environments/environment";
import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, tap} from "rxjs";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
    providedIn: 'root'
})

export class BacklogService {
    constructor(private http: HttpClient) {}
    /**
     * obtener los servicios registrados
     */
    getservices():Observable<any>{
        const body = JSON.stringify('');
        const headers = new HttpHeaders()
            .set('X-Api-Key', `${API_KEY}`)
            .set('Content-Type', 'application/json');
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/backlog/getservices`,
            body,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    };
    /**
     * Función para obtener la dirección
     */
    getAddress(data:any):Observable<any> {
        const body = JSON.stringify({form:data});
        const headers = new HttpHeaders()
            .set('X-Api-Key', `${API_KEY}`)
            .set('Content-Type', 'application/json');
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/backlog/getserviceaddress`,
            body,
            { headers }
        ).pipe(
            tap(() =>{
                this.controlLoader(false);
            })
        )
    }
    actionBacklog(data:any, nameFunction:string):Observable<any>{
        const body = JSON.stringify({form:data});
        const headers = new HttpHeaders()
            .set('X-Api-Key', `${API_KEY}`)
            .set('Content-Type', 'application/json');
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/backlog/`+nameFunction,
            body,
            { headers }
        ).pipe(
            tap(() =>{
                this.controlLoader(false);
            })
        )
    }
    getEmployee(data:any):Observable<any>{
        const body = JSON.stringify({form:data});
        const headers = new HttpHeaders()
            .set('X-Api-Key', `${API_KEY}`)
            .set('Content-Type', 'application/json');
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/employee/transferdriver`,
            body,
            { headers }
        ).pipe(
            tap(() =>{
                this.controlLoader(false);
            })
        )
    }
    getVehicle(data:any):Observable<any>{
        const body = JSON.stringify({type:'all', data:data});
        const headers = new HttpHeaders()
            .set('X-Api-Key', `${API_KEY}`)
            .set('Content-Type', 'application/json');
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/vehicle/findvehicle`,
            body,
            { headers }
        ).pipe(
            tap(() =>{
                this.controlLoader(false);
            })
        )
    }


    /**
     * Función para mostrar o remover loading
     */
    controlLoader(show:boolean):void{
        //let elemet: any = document.getElementsByClassName("loader-screen")[0];
        //elemet.style.opacity = 0.8;
        //elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
    }
}